document.addEventListener('DOMContentLoaded', function () {

    // set mobile / desktop video version
    const video = document.querySelector('.LpSokolMovementVideo');
    const videoWrapper = document.querySelector('.LpSokolMovement');

    if (!video || !videoWrapper) return;

    let videoSource = video.getAttribute('data-source-mobile');

    if (window.innerWidth > 1280) {
        videoSource = video.getAttribute('data-source-desktop');
    }

    video.insertAdjacentHTML('afterbegin', `<source src='${videoSource}' type='video/mp4'>`)

    // mute / unmute video
    videoWrapper.querySelector('.VolumeSwitcher').addEventListener('click', function (e) {
        e.preventDefault();

        if (video.muted) {
            //video.removeAttribute('muted')
            $(video).prop('muted', false);
            video.muted = false;
            video.setAttribute('data-muted', false);
        }
        else {
            //video.setAttribute('muted', true)
            $(video).prop('muted', true);
            video.muted = true;
            video.setAttribute('data-muted', true);
        }
    });
});